import { render, staticRenderFns } from "./DocAccessType.vue?vue&type=template&id=b3ce0a54"
import script from "./DocAccessType.vue?vue&type=script&lang=js"
export * from "./DocAccessType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports